abstract class TCStringDecoder {

    /**
     * Decodifica una cadena de TcString e informa sus valores en un objeto.
     * @param tcString Cadena codificada en base64 con la TcString.
     * @param obj Objeto donde informar la cadena.
     */
    public abstract decode(tcString:string, obj:any) : void;
}

export {TCStringDecoder}
